import React, { useState } from 'react';

function AppButton({
  children,
  className = '',
  onClick,
  type = 'button',
  disabled = false,
  ...props
}) {
  const [ripples, setRipples] = useState([]);

  const handleClick = (event) => {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const ripple = {
      id: Date.now() + Math.random(),
      size,
      x: event.clientX - rect.left - size / 2,
      y: event.clientY - rect.top - size / 2,
    };

    setRipples((prev) => [...prev, ripple]);
    window.setTimeout(() => {
      setRipples((prev) => prev.filter((item) => item.id !== ripple.id));
    }, 600);

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      type={type}
      className={`app-button ${className}`.trim()}
      onClick={handleClick}
      disabled={disabled}
      {...props}
    >
      <span className="app-button__label">{children}</span>
      <span className="app-button__ripple-wrapper" aria-hidden="true">
        {ripples.map((ripple) => (
          <span
            key={ripple.id}
            className="app-button__ripple"
            style={{
              width: `${ripple.size}px`,
              height: `${ripple.size}px`,
              left: `${ripple.x}px`,
              top: `${ripple.y}px`,
            }}
          />
        ))}
      </span>
    </button>
  );
}

export default AppButton;
